interface GrowthBookState {
  features: Record<string, unknown>
  isLoading: boolean
}

const initialState: GrowthBookState = {
  features: {},
  isLoading: true,
}

const growthbookReducer = (
  state: GrowthBookState | undefined = initialState,
  action: { type: string; payload: unknown } = {
    type: '',
    payload: {},
  },
) => {
  if (!action) return state

  switch (action.type) {
    case 'SET_GROWTHBOOK_FEATURES':
      return {
        ...state,
        features: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default growthbookReducer
